(() => {
  const selector = '.is-t4s-style__color [data-swatch-item]';
  const refresh = scope => {
    scope.querySelectorAll(selector).forEach(swatch => {
      swatch.setAttribute('role', 'button');
      swatch.tabIndex = 0;
      swatch.setAttribute('aria-pressed', String(swatch.classList.contains('is--selected')));
      const name = swatch.getAttribute('title') || swatch.textContent.trim();
      if (name) swatch.setAttribute('aria-label', name);
    });
  };
  const start = () => {
    refresh(document);
    document.addEventListener('keydown', event => {
      const swatch = event.target.closest(selector);
      if (!swatch || !['Enter', ' '].includes(event.key) || event.repeat) return;
      event.preventDefault();
      swatch.click();
    });
    new MutationObserver(records => {
      if (records.some(record => record.type === 'childList' || record.target.matches(selector))) refresh(document);
    }).observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['class']});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
